/* Elora — testimonial slider. LP cards fit their active review; touch_lock keeps
   horizontal card gestures separate from native vertical scrolling and pinch zoom. */
(function () {
  var Elora = (window.Elora = window.Elora || {});
  if (Elora.testimonials) {
    Elora.testimonials.init(document);
    return;
  }

  function initRoot(root) {
    if (root.hasAttribute('data-elora-testimonials-ready')) return;
    var track = root.querySelector('[data-elora-track]');
    if (!track || !track.children.length) return;
    root.setAttribute('data-elora-testimonials-ready', '');

    var view = track.parentElement;
    var slides = Array.prototype.slice.call(track.children);
    var n = slides.length;
    var prev = root.querySelector('[data-elora-prev]');
    var next = root.querySelector('[data-elora-next]');
    var dotBox = root.querySelector('[data-elora-dots]');
    var dots = dotBox ? Array.prototype.slice.call(dotBox.querySelectorAll('[data-elora-dot]')) : [];
    var lock = root.hasAttribute('data-hm-gesture');
    var gestureTarget = lock ? view : track;
    var cards = root.classList.contains('tm--cards');
    var mobile = window.matchMedia('(max-width: 767px)');
    var idx = 0;
    var raf = 0;
    var removers = [];
    var observer;
    var gesture = null;
    var suppressClickUntil = 0;

    function listen(target, type, handler, options) {
      target.addEventListener(type, handler, options);
      removers.push(function () { target.removeEventListener(type, handler, options); });
    }

    function offsetFor(i) {
      var width = slides[0].getBoundingClientRect().width;
      var gap = parseFloat(getComputedStyle(slides[0]).marginRight) || 0;
      var max = Math.max(0, n * width + (n - 1) * gap - view.clientWidth);
      return Math.max(0, Math.min(i * (width + gap), max));
    }

    function translate(offset) {
      track.style.setProperty('--tm-offset', offset + 'px');
    }

    function fitHeight() {
      if (cards && mobile.matches) {
        view.style.setProperty('--tm-view-height', Math.ceil(slides[idx].getBoundingClientRect().height) + 'px');
      } else {
        view.style.removeProperty('--tm-view-height');
      }
    }

    function resetGesture() {
      gesture = null;
      track.removeAttribute('data-elora-dragging');
      translate(offsetFor(idx));
    }

    function go(i) {
      var nextIndex = Math.max(0, Math.min(n - 1, i));
      if (idx !== nextIndex) {
        track.querySelectorAll('[data-tm-det][open]').forEach(function (detail) {
          detail.removeAttribute('open');
        });
      }
      idx = nextIndex;
      resetGesture();
      dots.forEach(function (dot, j) {
        dot.classList.toggle('is-on', j === idx);
        if (j === idx) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      slides.forEach(function (slide, j) {
        slide.setAttribute('aria-hidden', j === idx ? 'false' : 'true');
        if (cards || lock) slide.inert = j !== idx;
      });
      if (prev) prev.disabled = idx === 0;
      if (next) next.disabled = idx === n - 1;
      fitHeight();
    }

    if (prev) listen(prev, 'click', function () { go(idx - 1); });
    if (next) listen(next, 'click', function () { go(idx + 1); });
    if (dotBox) listen(dotBox, 'click', function (event) {
      var dot = event.target.closest('[data-elora-dot]');
      if (dot) go(parseInt(dot.getAttribute('data-elora-dot'), 10));
    });

    function currentTouch(touches) {
      if (!gesture) return null;
      for (var i = 0; i < touches.length; i++) {
        if (touches[i].identifier === gesture.id) return touches[i];
      }
      return null;
    }

    // Keep the listener region stationary while the track moves beyond its own
    // border box. Capture also covers touches retargeted from an inert slide.
    listen(gestureTarget, 'touchstart', function (event) {
      if (event.touches.length !== 1 || n < 2 || (lock && event.target.closest('a, button, summary, input, select, textarea'))) {
        resetGesture();
        return;
      }
      var touch = event.touches[0];
      gesture = { id: touch.identifier, x: touch.clientX, y: touch.clientY, axis: null };
    }, { passive: true, capture: lock });

    listen(gestureTarget, 'touchmove', function (event) {
      var touch = currentTouch(event.touches);
      if (!touch || event.touches.length !== 1) {
        resetGesture();
        return;
      }
      var dx = touch.clientX - gesture.x;
      var dy = touch.clientY - gesture.y;
      if (!gesture.axis && Math.max(Math.abs(dx), Math.abs(dy)) >= 10) {
        gesture.axis = Math.abs(dx) >= Math.abs(dy) * 1.25 ? 'x' : 'y';
      }
      if (!lock || gesture.axis !== 'x') return;
      // A browser-owned scroll/pinch cannot be reclaimed midway through a gesture.
      if (!event.cancelable) {
        resetGesture();
        return;
      }
      event.preventDefault();
      track.setAttribute('data-elora-dragging', '');
      var lower = offsetFor(Math.max(0, idx - 1));
      var upper = offsetFor(Math.min(n - 1, idx + 1));
      translate(Math.max(lower, Math.min(offsetFor(idx) - dx, upper)));
    }, { passive: !lock, capture: lock });

    listen(gestureTarget, 'touchend', function (event) {
      var touch = currentTouch(event.changedTouches);
      if (!touch || event.touches.length) {
        resetGesture();
        return;
      }
      var dx = touch.clientX - gesture.x;
      var horizontal = !lock || gesture.axis === 'x';
      if (lock && gesture.axis === 'x' && Math.abs(dx) >= 10) suppressClickUntil = Date.now() + 400;
      if (horizontal && Math.abs(dx) > 45) go(idx + (dx < 0 ? 1 : -1));
      else resetGesture();
    }, { passive: true, capture: lock });

    listen(gestureTarget, 'touchcancel', resetGesture, { passive: true, capture: lock });
    listen(gestureTarget, 'click', function (event) {
      if (Date.now() >= suppressClickUntil) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    function scheduleLayout() {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        raf = 0;
        resetGesture();
        fitHeight();
      });
    }
    listen(window, 'resize', scheduleLayout, { passive: true });
    listen(track, 'toggle', fitHeight, true);
    listen(track, 'load', fitHeight, true);
    if (window.ResizeObserver) {
      observer = new ResizeObserver(scheduleLayout);
      slides.forEach(function (slide) { observer.observe(slide); });
    }

    root.eloraTmCleanup = function () {
      removers.forEach(function (remove) { remove(); });
      if (observer) observer.disconnect();
      if (raf) window.cancelAnimationFrame(raf);
      view.style.removeProperty('--tm-view-height');
      track.style.removeProperty('--tm-offset');
      track.removeAttribute('data-elora-dragging');
      slides.forEach(function (slide) { slide.removeAttribute('aria-hidden'); slide.inert = false; });
      root.removeAttribute('data-elora-testimonials-ready');
      delete root.eloraTmCleanup;
    };
    go(0);
  }

  function rootsWithin(scope) {
    var roots = Array.prototype.slice.call(scope.querySelectorAll('[data-elora-testimonials]'));
    if (scope.matches && scope.matches('[data-elora-testimonials]')) roots.unshift(scope);
    return roots;
  }

  function init(scope) {
    rootsWithin(scope && scope.querySelectorAll ? scope : document).forEach(initRoot);
  }

  Elora.testimonials = { init: init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });
  document.addEventListener('shopify:section:unload', function (event) {
    rootsWithin(event.target || document).forEach(function (root) {
      if (root.eloraTmCleanup) root.eloraTmCleanup();
    });
  });
})();
